// stroke
// Components with Indicators are a little bit different and require different viewBox sizes than the
// regular icon components. This is why we have to create a separate svg for them.
const BookmarkWithIndicator = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  if (width === '16' && height === '16') {
    return (
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden={`${hidden}`}
        role={role ? role : hidden ? 'graphics-document' : 'img'}
      >
        {!hidden && <title>{title}</title>}
        <path
          d="M11.7377 15.4192L7.97053 12.7822L4.20336 15.4192C4.13638 15.4661 4.05784 15.4937 3.97627 15.499C3.89469 15.5044 3.81322 15.4873 3.7407 15.4495C3.66818 15.4118 3.6074 15.3549 3.56496 15.285C3.52252 15.2152 3.50005 15.135 3.5 15.0532V3.39411C3.5 3.15697 3.5942 2.92955 3.76188 2.76188C3.92955 2.5942 4.15697 2.5 4.39411 2.5H11.5469C11.7841 2.5 12.0115 2.5942 12.1792 2.76188C12.3469 2.92955 12.4411 3.15697 12.4411 3.39411V15.0532C12.441 15.135 12.4185 15.2152 12.3761 15.285C12.3337 15.3549 12.2729 15.4118 12.2004 15.4495C12.1278 15.4873 12.0464 15.5044 11.9648 15.499C11.8832 15.4937 11.8047 15.4661 11.7377 15.4192Z"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <path
          d="M6.18231 2.50098V14.0343"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <path
          d="M9.75873 2.50098V14.0343"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <circle cx="12.8" cy="3.11104" r="2.3" fill="#BA1E50" stroke="white" />
      </svg>
    );
  } else {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        stroke="#000000"
        aria-hidden={`${hidden}`}
        role={role ? role : hidden ? 'graphics-document' : 'img'}
      >
        {!hidden && <title>{title}</title>}
        <path
          d="M17.2667 21.9723L12 18.2856L6.73333 21.9723C6.6397 22.0378 6.52988 22.0764 6.41584 22.0839C6.3018 22.0914 6.18789 22.0674 6.08651 22.0147C5.98512 21.9619 5.90015 21.8824 5.84082 21.7847C5.78149 21.687 5.75007 21.5749 5.75 21.4606V5.16064C5.75 4.82912 5.8817 4.51118 6.11612 4.27676C6.35054 4.04234 6.66848 3.91064 7 3.91064H17C17.3315 3.91064 17.6495 4.04234 17.8839 4.27676C18.1183 4.51118 18.25 4.82912 18.25 5.16064V21.4606C18.2499 21.5749 18.2185 21.687 18.1592 21.7847C18.0999 21.8824 18.0149 21.9619 17.9135 22.0147C17.8121 22.0674 17.6982 22.0914 17.5842 22.0839C17.4701 22.0764 17.3603 22.0378 17.2667 21.9723Z"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <path
          d="M9.5 3.91162V20.0358"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <path
          d="M14.5 3.91162V20.0358"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <circle cx="19" cy="5" r="4" fill="#BA1E50" stroke="white" strokeWidth="2" />
      </svg>
    );
  }
};

export default BookmarkWithIndicator;
